import React from 'react';
import './Legal.css';

const Anulare = () => {
  return (
    <>


      <div className="legal-container">
        <div className="legal-content">
          <div className="legal-section">
            <p><strong>Ultima actualizare:</strong> 28 noiembrie 2024</p>

            <h3>1. Anulare rezervări</h3>
            <p>Pentru a anula o rezervare, vă rugăm să ne contactați:</p>
            <ul>
              <li>Email: m_adi_i@yahoo.com</li>
              <li>Telefon: 0745573126</li>
            </ul>

            <h3>2. Termene și condiții</h3>
            <p><strong>Important:</strong> Întârzierile la lecții nu conduc la decalarea programului sau reprogramarea lecției.</p>
            <p>Ora de începere a lecției este fixă conform rezervării efectuate.</p>

            <h3>3. Neprezentare</h3>
            <p><strong>Neprezentarea la lecție nu este rambursabilă.</strong></p>
            <p>În cazul în care nu vă prezentați la lecția programată, suma plătită nu va fi returnată.</p>

            <h3>4. Rambursare</h3>
            <p>Rambursările se efectuează doar în următoarele situații:</p>
            <ul>
              <li>Anulare din partea instructorului sau a școlii</li>
              <li>Condiții meteo extreme care nu permit desfășurarea lecției</li>
              <li>Alte circumstanțe excepționale evaluate de către școală</li>
            </ul>
            <p>Procesul de rambursare se derulează în termen de 5-10 zile lucrătoare.</p>

            <h3>5. Modificare rezervare</h3>
            <p>Modificarea datei sau orei lecției este posibilă în funcție de disponibilitatea instructorului.</p>
            <p>Pentru modificări, contactați-ne cu minimum 24 de ore înainte de lecție.</p>

            <h3>6. Contact</h3>
            <p>Pentru întrebări despre anulări și reprogramări: m_adi_i@yahoo.com | 0745573126</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Anulare;